export type MetalType = 'silver' | 'gold'

export interface CoinPreset {
  id: string
  name: string
  metal: MetalType
  weightOz: number
  purity: number
  strikePremiumPct: number
  defaultSpot: number
}

export const coinPresets: CoinPreset[] = [
  { id: 'silverEagle', name: 'American Silver Eagle (1 oz)', metal: 'silver', weightOz: 1.0000, purity: 0.999, strikePremiumPct: 18, defaultSpot: 28 },
  { id: 'goldEagle', name: 'American Gold Eagle (1 oz)', metal: 'gold', weightOz: 1.0909, purity: 0.9167, strikePremiumPct: 5, defaultSpot: 2650 },
  { id: 'junkSilver', name: 'Pre-1965 90% Silver Dime', metal: 'silver', weightOz: 0.0804, purity: 0.90, strikePremiumPct: 3, defaultSpot: 28 },
  { id: 'morganDollar', name: 'Morgan Silver Dollar', metal: 'silver', weightOz: 0.8594, purity: 0.90, strikePremiumPct: 10, defaultSpot: 28 },
  { id: 'mapleLeafSilver', name: 'Canadian Silver Maple Leaf (1 oz)', metal: 'silver', weightOz: 1.0000, purity: 0.9999, strikePremiumPct: 15, defaultSpot: 28 },
  { id: 'mapleLeafGold', name: 'Canadian Gold Maple Leaf (1 oz)', metal: 'gold', weightOz: 1.0000, purity: 0.9999, strikePremiumPct: 4, defaultSpot: 2650 },
  { id: 'krugerrand', name: 'South African Krugerrand (1 oz)', metal: 'gold', weightOz: 1.0909, purity: 0.9167, strikePremiumPct: 4, defaultSpot: 2650 },
  { id: 'goldBuffalo', name: 'American Gold Buffalo (1 oz .9999)', metal: 'gold', weightOz: 1.0000, purity: 0.9999, strikePremiumPct: 5, defaultSpot: 2650 },
]

export const gradeMultipliers: { id: string, label: string, multiplier: number }[] = [
  { id: 'circulated', label: 'Circulated', multiplier: 1.0 },
  { id: 'au50', label: 'AU-50 (About Uncirculated)', multiplier: 1.15 },
  { id: 'ms60', label: 'MS-60 (Uncirculated)', multiplier: 1.3 },
  { id: 'ms65', label: 'MS-65 Gem Mint', multiplier: 1.75 },
  { id: 'ms70', label: 'MS-70 Perfect Mint', multiplier: 3.0 },
  { id: 'proof70', label: 'Proof 70 Cameo', multiplier: 4.0 },
]
